import { Box, ButtonBase } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

interface LugarCorreccionProps {
    /** "paso Responsables", "se corrige en Establecimientos" (ver `lugarDeCorreccion`). */
    lugar: string;
    /**
     * true si se corrige en un paso de este informe; false si es en otra pantalla
     * (Establecimientos, nómina). Cambia el color: lo de afuera va en ámbar
     * porque el cliente tiene que salir del informe para arreglarlo.
     */
    enInforme: boolean;
    /** Si viene, la etiqueta es un link (p. ej. a editar el establecimiento). */
    onClick?: () => void;
}

/**
 * Dónde se corrige una observación, como etiqueta visible. Antes era un texto
 * gris chico debajo del mensaje y no se distinguía (pedido del 06/10/2026).
 * Lo usan el panel de correcciones del informe y el aviso de la página de
 * presentaciones.
 */
const LugarCorreccion = ({ lugar, enInforme, onClick }: LugarCorreccionProps) => {
    const Icono = enInforme ? ArrowForwardRoundedIcon : OpenInNewRoundedIcon;
    const texto = lugar.charAt(0).toUpperCase() + lugar.slice(1);
    const sx = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        mt: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: '999px',
        fontFamily: 'inherit',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.5,
        ...(enInforme
            ? {
                  color: 'primary.main',
                  bgcolor: (theme: any) => alpha(theme.palette.primary.main, 0.1)
              }
            : { color: '#8A4B00', bgcolor: '#FFF1DC' })
    };

    if (onClick) {
        return (
            <ButtonBase
                data-testid="lugar-correccion"
                onClick={onClick}
                sx={{
                    ...sx,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px',
                    '&:hover': { filter: 'brightness(0.95)' }
                }}
            >
                <Icono sx={{ fontSize: 14 }} aria-hidden />
                {texto}
            </ButtonBase>
        );
    }

    return (
        <Box component="span" data-testid="lugar-correccion" sx={sx}>
            <Icono sx={{ fontSize: 14 }} aria-hidden />
            {texto}
        </Box>
    );
};

export default LugarCorreccion;
